/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { memo } from 'react'
// TODO: Remove 'as' type assertions because they are unsafe.
import { Container } from '../Grid'
import { NAV_PLUS_HEADER_HEIGHT } from 'd2/components/Sticky/styles'
import { SPACING } from 'd2/constants'
import { px } from 'd2/utils/style'
import { startCase } from 'lodash-es'
import MetadataBox from 'd2/components/MetadataBox'
import MetadataBoxRow from 'd2/components/MetadataBoxRow'
import Modal from 'd2/components/Modal'
import ScrollableContainer from '../ScrollableContainer'
import useTranslations from './translations'
import type { Props } from './types'

const TrackMetadataModal = memo<Props>(({
  artistName,
  audioIsrc,
  collaboratingArtists,
  copyrightName,
  copyrightYear,
  genre,
  hideModal,
  label,
  lyrics,
  modalIndex,
  trackName,
}) => {
  const t = useTranslations()

  return (
    <Modal
      divider
      heading={t.trackDetails}
      id='track-metadata-modal'
      modalIndex={modalIndex}
      modalKey='TrackMetadataModal'
      onToggleClose={hideModal}
    >
      <ScrollableContainer
        maxHeight={`calc(90vh - ${px(NAV_PLUS_HEADER_HEIGHT + SPACING)})`} // NOTE: this is not an exact value, just a best guess.
      >
        <Container>
          <MetadataBox>
            <MetadataBoxRow
              label={t.labelTrackName}
              noTruncate
            >
              { trackName || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelArtistName}
              noTruncate
            >
              { artistName || t.noData }
            </MetadataBoxRow>
            { collaboratingArtists?.map(({ id, name, role }) => (
              <MetadataBoxRow
                key={id}
                label={startCase(role)}
                noTruncate
              >
                { name || t.noData }
              </MetadataBoxRow>
            )) }
            <MetadataBoxRow
              label={t.labelGenre}
              noTruncate
            >
              { genre || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelAudioIsrc}
              noTruncate
            >
              { audioIsrc || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelLabel}
              noTruncate
            >
              { label || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelCopyrightName}
              noTruncate
            >
              { copyrightName || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelCopyrightYear}
              noTruncate
            >
              { copyrightYear || t.noData }
            </MetadataBoxRow>
            <MetadataBoxRow
              label={t.labelLyrics}
              lyrics
              noTruncate
            >
              { lyrics || t.noData }
            </MetadataBoxRow>
          </MetadataBox>
        </Container>
      </ScrollableContainer>
    </Modal>
  )
})

TrackMetadataModal.displayName = 'TrackMetadataModal'

export default TrackMetadataModal
